// Single source of truth for site navigation, shared by the homepage (dark)
// header and the inner-page (white) header so the nav stays consistent everywhere.

export const SERVICE_LINKS = [
  { label: 'All Services', href: '/services', slug: 'services-hub' },
  { label: 'BI & Dashboards', href: '/services/bi-dashboards', slug: 'bi-dashboards' },
  { label: 'Data Strategy', href: '/services/data-strategy', slug: 'data-strategy' },
  { label: 'Advanced Analytics', href: '/services/advanced-analytics', slug: 'advanced-analytics' },
  { label: 'Tableau Consulting', href: '/services/tableau-consulting', slug: 'tableau-consulting' },
  { label: 'Power BI Consulting', href: '/services/power-bi-consulting', slug: 'power-bi-consulting' },
];

export const NAV_LINKS = [
  { label: 'Work', href: '/case-studies', slug: 'work' },
  { label: 'Insights', href: '/insights', slug: 'insights' },
  { label: 'About', href: '/about', slug: 'about' },
  { label: 'Contact', href: '/contact', slug: 'contact' },
];

export const BOOK_CTA = { label: 'Book a Free Assessment', href: '/analytics-assessment' };
